import { QuestionBase } from './question-base.model';

export class FormWithGrid extends QuestionBase<string> {
    controlType = 'formwithgrid';
    dataResource: any;
    data: any;
    visible: string;
    pagination: any;
    constructor(options: {} = {}) {
        super(options);
        this.dataResource = options['dataResource'];
        this.data = options['data'];
        this.visible = options['visible'] || 'true';
        this.pagination = options['pagination'];
    }
}
